import Background from "three/src/renderers/common/Background.js";
import "./../styles/service.css";
import React from "react";
// import React from 'react';
const DigitalTwin = () => {
  const advantageList = [
    {
      src: "/assets/advantage5.png",
      title: "效率优势",
      content:
        "基于矢量切片技术，地图加载速度快，多源数据快速导入、数据加载秒级响应、支持多图层管理、搜索响应速度快、发布速度快。",
    },
    {
      src: "/assets/advantage6.png",
      title: "技术优势",
      content:
        "动态矢量切片、MVT矢量瓦片技术、图层组管理、地图样式库；数据高效检索，快速地从海量的数据存储中定位和提取所需的数据，达到快速查询响应的目标。",
    },
    {
      src: "/assets/advantage7.png",
      title: "数据管理优势",
      content:
        "支持对用户的时空数据进行清洗、存储、管理、分析、发布；支持海量图层的加载，支持权限体系配置。",
    },
    {
      src: "/assets/advantage6.png",
      title: "部署优势",
      content:
        "部署灵活，支持物理机，虚拟机及云环境下的容器化部署，支持国产化（信创）的要求。",
    },
  ];
  const functionList = [
    {
      src: "/assets/funcation-GIS-1.png",
      title: "地理数据服务",
      content:
        "将地理空间数据通过金字塔模型构建地图缓存库，采用明码格式对数据集、层、行目录结构进行描述，数据预缓存既地图矢量切片，有效减轻了服务器端实时渲染地图的处理压力，提高了系统的响应能力。并提供地理编码服务，提供输入地址文本描述返回经纬度坐标信息。",
    },
    {
      src: "/assets/funcation-GIS-2.png",
      title: "基础GIS引擎服务",
      content:
        "提供POI检索服务、AOI检索服务、路网检索服务、行政区划定位查询服务、空间几何图形计算服务、地理围栏服务等基础服务。",
    },
    {
      src: "/assets/funcation-GIS-3.png",
      title: "地图可视化服务",
      content:
        "提供地图可视化、大数据渲染服务、支持业务数据叠加地图展示服务，支持JSAPI服务形式展示地图，数据分层级加载，实现如点聚合、热力图等相关的服务调用接口。",
    },
    {
      src: "/assets/funcation-GIS-4.png",
      title: "空间数据存储服务",
      content:
        "支持多源异构数据存储，如CSV/SHP/GDB/GEOJSON/TIFF等空间数据进行统一数据存储；支持对接第三方数据库，支持对接MySQL、Postgresql多种第三方数据库进行OGC发布。",
    },
    {
      src: "/assets/funcation-GIS-5.png",
      title: "空间数据管理服务",
      content:
        "不仅支持时空数据的标准化、数据编辑以及数据浏览等基础服务，而且还支持针对数据的多维度查询，包括数据查询与统计等功能，全方位满足用户在数据处理与分析方面的需求，为用户提供高效、便捷的数据管理与运用解决方案。",
    },
    {
      src: "/assets/funcation-GIS-6.png",
      title: "空间数据发布服务",
      content:
        "支持按照标准OGC协议的图层发布，支持WMS/WMTS/WFS协议发布，以及服务发布管理、服务状态监控等功能。",
    },
  ];

  return (
    <div className="service">
      <img src="/assets/service.png" alt="服务能力" />
      <div className="title">
        <div className="titleBefore">GIS服务平台</div>
        <div className="titleEnd">GIS SERVICE PLATFORM</div>
        <div className="temp"></div>
      </div>

      <div className="content2">
        <div
          className="content-item1"
          style={{ backgroundImage: `url(/assets/bgGIS.png)` }}
        >
          <div className="content-title">产品介绍</div>
          <div className="content-content">
            基于自研国产化
            GIS引擎的服务平台，提供矢量切片、搜索定位、空间分析等服务，用动态矢量切片统一管理空间地理数据，能清洗、分析、发布数据，支持API
            定制与私有部署，安全可靠且可灵活扩展。
          </div>
        </div>
        <div className="content-item2">
          <div className="content-title">产品优势</div>
          <div className="content-content">
            {advantageList.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <img src={item.src} alt={item.title} />
                  <div className="item-title">{item.title}</div>
                  <span>{item.content}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="content-item3">
          <div className="content-item3-temp">
            <div className="content-title">产品功能</div>
            <div className="content-content">
              <div className="content-content-item">
                <div>
                  {functionList.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className="content-content-item-title">
                          <img src={item.src} alt={item.title} />
                          <span>{item.title}</span>
                        </div>
                        <div className="content-content-item-content">
                          {item.content}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content-item4">
          <div className="content-title">应用场景</div>
          <div className="content-content">
            <div className="content-content-item">
              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>通信运营商行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">
                    各省市级通信运营商（联通、移动、电信）网络部、综合资源管理等。
                  </div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">
                    全业务一张图，构建统一GIS一张图
                  </div>
                </div>
              </div>

              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>政府行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">公安、大数据局</div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">警用地理信息平台</div>
                </div>
              </div>
              <div className="content-content-item-title">
                <img src="/assets/point-icon.png" />
                <span>能源行业</span>
              </div>
              <div className="content-content-item-content">
                <div className="item">
                  <div className="item-title">客户群体</div>
                  <div className="item-content">园区管理者、景区管理者</div>
                </div>
                <div className="item">
                  <div className="item-title">应用场景</div>
                  <div className="item-content">
                    园区业务管理数字底座、景区地图
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content-end">
          加入云网合作伙伴，开创新业务，获取技术、资源
        </div>
      </div>
    </div>
  );
};
export default DigitalTwin;
